import { ActionReducerMap } from '@ngrx/store';
import { routerReducer, RouterReducerState } from '@ngrx/router-store';

import { initialVetState, VetEffects, VetFacade, VetState, vetReducer } from '@app/store/vet';
import { PetState, initialPetState, petReducer, PetEffects } from '@app/store/pet';
import { PatientState, initialPatientState, patientReducer, PatientEffects, PatientFacade } from '@app/store/patient';
import { consultationReducer, ConsultationState, initialConsultationState } from './consultation';
import { ConsultationEffects } from './consultation/effects';
import { initialProductsState, ProductsEffects, productsReducer, ProductsState } from './products';
import { ProductsFacade } from '@app/store/products/products.facade';
import { ConsultationFacade } from '@app/store/consultation/consultation.facade';
import { initialShareRecommendationState, ShareRecommendationState } from './share-recommendation/share-recommendation.state';
import { ShareRecommendationEffects, ShareRecommendationFacade, shareRecommendationReducer } from './share-recommendation';
import { StateNamesEnum } from '@app/shared/utils/enums/state-names.enum';
import { PetFacade } from './pet/pet.facade';
import { CoreState, initialCoreState } from './core/core.state';
import { coreReducer } from './core/core.reducer';
import { CoreEffects } from './core/effects';
import { initialPatientProfileState, PatientProfileFacade, patientProfileReducer, PatientProfileState } from './patient-profile';
import { AllowanceEffects, AllowanceFacade, allowanceReducer, AllowanceState, initialAllowanceState } from './allowance';
import { RapidRecoFacade } from '@app/pages/rapid-reco/store/rapid-reco.facade';
import { PatientProfileEffects } from './patient-profile/effects';
import { DailyAllowanceFacade } from '@app/pages/daily-allowance/store/daily-allowance.facade';
import { NewPetFacade } from '@app/pages/new-pet/store/new-pet.facade';
import { RenalDetectFacade } from '@app/pages/renal-detect/store/renal-detect.facade';
import { SmartRecoFacade } from '@app/pages/smart-reco/store/smart-reco.facade';
import { WeightManagementFacade } from '@app/pages/weight-management/weight-management.facade';

export interface AppState {
  router?: RouterReducerState;
  [StateNamesEnum.CORE_STATE_NAME]: CoreState;
  [StateNamesEnum.VET_STATE_NAME]: VetState;
  [StateNamesEnum.PATIENT_STATE_NAME]: PatientState;
  [StateNamesEnum.CONSULTATION_STATE_NAME]: ConsultationState;
  [StateNamesEnum.PRODUCTS_STATE_NAME]: ProductsState;
  [StateNamesEnum.PET_STATE_NAME]: PetState;
  [StateNamesEnum.SHARE_RECOMMENDATION_STATE_NAME]: ShareRecommendationState;
  [StateNamesEnum.PATIENT_PROFILE_STATE_NAME]: PatientProfileState;
  [StateNamesEnum.ALLOWANCE]: AllowanceState;
}

export const initialAppState: AppState = {
  [StateNamesEnum.CORE_STATE_NAME]: initialCoreState,
  [StateNamesEnum.VET_STATE_NAME]: initialVetState,
  [StateNamesEnum.PATIENT_STATE_NAME]: initialPatientState,
  [StateNamesEnum.CONSULTATION_STATE_NAME]: initialConsultationState,
  [StateNamesEnum.PRODUCTS_STATE_NAME]: initialProductsState,
  [StateNamesEnum.PET_STATE_NAME]: initialPetState,
  [StateNamesEnum.SHARE_RECOMMENDATION_STATE_NAME]: initialShareRecommendationState,
  [StateNamesEnum.PATIENT_PROFILE_STATE_NAME]: initialPatientProfileState,
  [StateNamesEnum.ALLOWANCE]: initialAllowanceState,
};

export const appReducers: ActionReducerMap<AppState, any> = {
  router: routerReducer,
  [StateNamesEnum.CORE_STATE_NAME]: coreReducer,
  [StateNamesEnum.VET_STATE_NAME]: vetReducer,
  [StateNamesEnum.PATIENT_STATE_NAME]: patientReducer,
  [StateNamesEnum.CONSULTATION_STATE_NAME]: consultationReducer,
  [StateNamesEnum.PRODUCTS_STATE_NAME]: productsReducer,
  [StateNamesEnum.PET_STATE_NAME]: petReducer,
  [StateNamesEnum.SHARE_RECOMMENDATION_STATE_NAME]: shareRecommendationReducer,
  [StateNamesEnum.PATIENT_PROFILE_STATE_NAME]: patientProfileReducer,
  [StateNamesEnum.ALLOWANCE]: allowanceReducer,
};

export const appEffects: any[] = [
  ...CoreEffects,
  ...VetEffects,
  ...PatientEffects,
  ...PatientProfileEffects,
  ...ConsultationEffects,
  ...ProductsEffects,
  ...PetEffects,
  ShareRecommendationEffects,
  ...AllowanceEffects,
];

export const appFacades: any[] = [
  VetFacade,
  PatientFacade,
  ProductsFacade,
  ConsultationFacade,
  ShareRecommendationFacade,
  AllowanceFacade,
  PetFacade,
  PatientProfileFacade,
  DailyAllowanceFacade,
  NewPetFacade,
  RapidRecoFacade,
  RenalDetectFacade,
  SmartRecoFacade,
  WeightManagementFacade,
];
